import { ChartsBox } from "fleet/view/device/charts-box";
import { StatusBox } from "fleet/view/device/status-box";
import { TabbedIncidentsTable } from "fleet/view/incidents/tabbed-incidents-table";
import PropTypes from "prop-types";
import React from "react";
import { defaultArray, defaultObject } from "redux-store/selectors";
import { WrappedDeviceLtsFirmwareWarning } from "ui/device/lts-firmware-warning";
import { Notification } from "ui/notification";
import { Box } from "view/layout/box";

import { ConnectedDeviceTimeline } from "./connected-device-timeline";

class DeviceOverview extends React.PureComponent {
  static get propTypes() {
    return {
      applications: PropTypes.object.isRequired,
      device: PropTypes.object,
      deviceId: PropTypes.string.isRequired,
      deviceStatus: PropTypes.object.isRequired,
      deviceStatusOnline: PropTypes.bool,
      loadIncidentsByDeviceId: PropTypes.func.isRequired,
      incidents: PropTypes.object.isRequired,
      isThirdParty: PropTypes.bool.isRequired,
      stats: PropTypes.object.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      strategies: PropTypes.object.isRequired,
      unloadIncidents: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      successMessage: "",
    };

    this.incidentTableProps = {
      sizePerPage: 3,
      sizePerPageList: [3, 10, 25, 50].map((v) => ({
        text: String(v),
        value: v,
      })),
    };

    this.resolveMsgHandler = this.resolveMsgHandler.bind(this);
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.device && prevProps.device.id;
    const currId = this.props.device && this.props.device.id;

    if (prevId && currId && prevId !== currId) {
      this._fetchData();
    }
  }

  componentDidMount() {
    this._fetchData();
  }

  componentWillUnmount() {
    const { unloadIncidents } = this.props;
    unloadIncidents();
  }

  _fetchData() {
    const { deviceId, loadIncidentsByDeviceId } = this.props;
    loadIncidentsByDeviceId(deviceId);
  }

  resolveMsgHandler(message) {
    this.setState(message);
  }

  render() {
    const { successMessage, errorMessage } = this.state;

    const {
      applications,
      device,
      deviceStatus,
      deviceStatusOnline,
      isThirdParty,
      storesLoaded,
      strategies,
      incidents: _incidents,
      stats: _stats,
    } = this.props;

    if (!storesLoaded) {
      return null;
    }

    const { stats = defaultObject } = _stats;
    const { incidents = defaultArray } = _incidents;

    const incidentsTableData = Object.values(incidents);

    return (
      <div>
        <WrappedDeviceLtsFirmwareWarning device={device} />
        <Notification error={errorMessage} success={successMessage} />
        <StatusBox
          device={device}
          deviceStatus={deviceStatus}
          deviceStatusOnline={deviceStatusOnline}
          stats={stats}
        />
        <Box title="Device Incidents" type="default">
          <TabbedIncidentsTable
            tableData={incidentsTableData}
            resolveMsgHandler={this.resolveMsgHandler}
            {...this.incidentTableProps}
          />
        </Box>
        <ChartsBox
          strategies={strategies}
          applications={applications}
          isThirdParty={isThirdParty}
          stats={stats}
        />

        {!isThirdParty && (
          <ConnectedDeviceTimeline deviceId={device.device_id} />
        )}
      </div>
    );
  }
}

export { DeviceOverview };
